export enum EntityName {
  ORG = "Organisation",
  USER = "User",
  API_ACCOUNT = "API Account",
  LICENCE = "Licence",
  SOFTWARE_LICENCE = "Software Licence",
  PRICING = "Pricing",
  ORDER = "Order",
}
